import t from"styled-components";const e=t.div`
	display: flex;
	gap: 4px;
	align-items: center;

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type='number'] {
		-moz-appearance: textfield;
		appearance: textfield;
	}
`,n=t.div`
	display: grid;
	grid-template-columns: ${({numberOfItems:t})=>`repeat(${t}, 1fr)`};
	background-color: ${({theme:t})=>t.bg.primary};
	border-radius: 8px;
	padding: 4px;
	gap: 2px;
	width: 100%;
`,r=t.button`
	height: 32px;
	background-color: ${({isSelected:t,theme:e})=>t?e.border.black15:"transparent"};
	color: ${({theme:t})=>t.text.title};
	border-radius: 4px;
	display: grid;
	place-content: center;
	font-size: 12px;
	cursor: pointer;
	border: none;

	${({internalIconColorsHandling:t})=>t&&`\n\tsvg {\n\t\tfill: ${({theme:t})=>t.text.title};\n\n\t\tpath {\n\t\t\tfill: ${({theme:t})=>t.text.title};\n\t\t}\n\n\t\trect {\n\t\t\tfill: ${({theme:t})=>t.text.title};\n\t\t}\n\t}\n\t`}
`,i=t.input`
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	align-content: baseline;
	border-radius: 8px;
	border: 1px solid ${({theme:t})=>t.border.black15};
	text-align: center;
	background-color: ${({theme:t})=>t.bg.general};
	color: ${({theme:t})=>t.text.title};

	&:focus {
		outline: none;
	}
`;export{e as ButtonGroupContainer,r as GroupButton,n as GroupButtonContainer,i as GroupInput};
